import {Link, useParams} from 'react-router-dom';
import React/*, {useState}*/ from 'react';

import {useracc, postApi, setTitle, consoleLog} from '../../utils/functions';
import {UserContext, TestService} from '../../utils/usercontext';
import EventEmitter from '../../utils/emmiter';
//import Genres from './components/genres/genres';
//import AudioBox from './components/audio/audiobox';
//import moment from 'moment';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import '../components/fontawesome/fontawesome';
//import CopyBox from '../components/bbcode/copybox';

//import { Swiper, SwiperSlide } from 'swiper/react';
//import { Autoplay, Pagination, Navigation } from "swiper";
//import 'swiper/css';
import { createReactEditorJS } from 'react-editor-js';
import DiscordMessage from '../components/discord/discord';


import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Button from 'react-bootstrap/Button';
import { ButtonGroup } from 'react-bootstrap';

//import './css/index.css';
//import './css/header.css';

const ReactEditorJS = createReactEditorJS();

class PortalAdminDiscord extends React.Component {
  static contextType = UserContext;
  constructor(props) {
    super(props);
    this.state = {
			service: {
				status: false,
				id: this.props.service,
				name: '',
			},
			discord: {
				active: false,
				guild: [],
				guilds: [],
				members: [],
				bot: '',
				api: '',
			},
			schedule: {
				current: '',
				change: '',
			},
			flyer: {
				current: '',
				change: '',
			},
			live: {
				current: '',
				change: '',
			},
			clips: {
				current: '',
				change: '',
			},
			djrole: {
				current: '',
				change: '',
			},
			missingDjs: [],
			assignMissingDjs: [],
			/*{
				uid: 0,
				discord: 0
			},*/
			message_schedule: [],
			message_flyer: [],
			socialDiscord: {}
			//names: [],
			//embeds: [],
		};
		this.editorInstance = React.createRef();
		this.getDiscord = this.getDiscord.bind(this);
		this.authorise = this.authorise.bind(this);
		this.authoriseGuild = this.authoriseGuild.bind(this);
		this.changeSchedule = this.changeSchedule.bind(this);
		this.changeFlyer = this.changeFlyer.bind(this);
		this.changeLive = this.changeLive.bind(this);
		this.changeClips = this.changeClips.bind(this);
		this.changeDJRole = this.changeDJRole.bind(this);
		this.saveSocialDiscord = this.saveSocialDiscord.bind(this);
		this.assignMissingDj = this.assignMissingDj.bind(this);
		this.applyMissingDj = this.applyMissingDj.bind(this);
  };

  async componentDidMount() {
		//document.title = "Mix365 Radio - your music station streaming 24/7";
		const value = this.context;
		const getUser = await useracc();
		value.setUser( getUser );
		value.setTheme( getUser );
		const y = await value.setWorker( this.props.service );
		//let server = value.worker[this.props.service] || y[this.props.service];
		EventEmitter.emit('/client', y);

		let params = new URLSearchParams();
		params.append('service', this.state.service.id);
		const x = await postApi(`${this.context.worker[this.props.service]}/v3/admin/embeds`, params);

		//this.setState({names: x.data.names, embeds: x.data.embeds});

		let params2 = new URLSearchParams();
		params2.append('service', this.state.service.id);
		const z = await postApi(`/v3/portal/discord/bot`, params2);
		consoleLog(z.data);

		if( this.state.service.status === false ) {
			let service = this.state.service;
			service.status = true;
			service.name = x.data.servicename;
			//x.data.overview.shorttitle = x.data.description.title;
			let discord = this.state.discord;
			discord.active = z.data.active;
			discord.guild = z.data.guild;
			discord.guilds = z.data.guilds;
			discord.members = z.data.members;
			discord.bot = z.data.bot;
			discord.api = z.data.api;
			this.setState({service, discord});
			setTitle('Discord', x.data.servicename);
			if( discord.guild?.schedule ) {
				let schedule = this.state.schedule;
				schedule.current = schedule.change = discord.guild.schedule;
				this.setState({schedule, message_schedule: z.data.message_schedule?z.data.message_schedule:[], message_flyer: z.data.message_flyer?z.data.message_flyer:[]});
			}
			if( discord.guild?.flyer ) {
				let flyer = this.state.flyer;
				flyer.current = flyer.change = discord.guild.flyer;
				this.setState({flyer});
			}
			if( discord.guild?.live ) {
				let live = this.state.live;
				live.current = live.change = discord.guild.live;
				this.setState({live});
			}
			if( discord.guild?.clips ) {
				let clips = this.state.clips;
				clips.current = clips.change = discord.guild.clips;
				this.setState({clips});
			}
			if( discord.guild?.djrole ) {
				let djrole = this.state.djrole;
				djrole.current = djrole.change = discord.guild.djrole;
				this.setState({djrole});
			}
			if( z.data.socialDiscord ) {
				this.setState({socialDiscord: z.data.socialDiscord?JSON.parse(z.data.socialDiscord):[]});
			}
			if( z.data.missingDjs ) {
				this.setState({missingDjs: z.data.missingDjs});
			}
			
		};

		//let params = new URLSearchParams();
		//const x = await postApi(`${server}/v3/admin/organiser`, params);
		//this.setState({status: true, services: x.data.Services});

		/*
		let params = new URLSearchParams();
		const x = await postApi('/v3/index', params);
		//this.setState({clubbers: x.data.Clubbers, radio: x.data.Radio, next: x.data.Next, posters: x.data.WeeklyDJs, sets: x.data.Sets, status: true, affliiate: x.data.Affiliate});

		const IndexSchedule = EventEmitter.addListener('/index/schedule', async data => {
			this.setState({next: data.Next, live: data.Live});
		}); this.setState({IndexSchedule});
		*/

	}

	componentWillUnmount() {
	}


	async getDiscord() {
		let params = new URLSearchParams();
		params.append('service', this.state.service.id);
		const z = await postApi(`/v3/portal/discord/bot`, params);
		consoleLog(z.data);

		let discord = this.state.discord;
		discord.active = z.data.active;
		discord.guild = z.data.guild;
		discord.guilds = z.data.guilds;
		discord.bot = z.data.bot;
		discord.api = z.data.api;
		
		//console.log(JSON.parse(z.data.socialDiscord));
		this.setState({discord: {active: false, guild: [], guilds: [], bot: '', api: ''}, socialDiscord: z.data.socialDiscord?JSON.parse(z.data.socialDiscord):[]},()=>{
			this.setState({discord});
		});

	}


	async authorise() {
		let params = new URLSearchParams();
		params.append('service', this.state.service.id);
		params.append('id', 0);
		params.append('platform', 'discord');
		let x = await postApi(`/v3/portal/platforms`, params);
		consoleLog(x.data);
	}


	async authoriseGuild(id) {
		let params = new URLSearchParams();
		params.append('service', this.state.service.id);
		params.append('id', id);
		const x = await postApi(`/v3/portal/discord/api`, params);
		consoleLog(x.data);
		if( x.status === 200 ) {

			/*
			const z = await postApi(`/v3/portal/discord/bot`, params2);
			
			let discord = this.state.discord;
			discord.active = z.data.active;
			discord.guild = z.data.guild;
			discord.guilds = z.data.guilds;
			discord.bot = z.data.bot;
			discord.api = z.data.api;
			
			this.setState({discord: []});
			*/

		}
	}

	async changeSchedule(item, save = false, cancel = false) {
		let schedule = this.state.schedule;
		if( cancel ) {
			schedule.current = this.state.discord.guild.schedule;
			schedule.change = this.state.discord.guild.schedule;
			this.setState({schedule});
			return;
		}
		if( save ) {
			schedule.current = schedule.change;
			this.setState({schedule});
			let params = new URLSearchParams();
			params.append('service', this.state.service.id);
			params.append('schedule', schedule.change);
			await postApi(`/v3/portal/discord/api`, params);
			
			await this.getDiscord();
			return;
		}
		schedule.current = this.state.discord.guild.schedule;
		schedule.change = item.target.value;
		this.setState({schedule})
	}

	async changeFlyer(item, save = false, cancel = false) {
		let flyer = this.state.flyer;
		if( cancel ) {
			flyer.current = this.state.discord.guild.flyer;
			flyer.change = this.state.discord.guild.flyer;
			this.setState({flyer});
			return;
		}
		if( save ) {
			flyer.current = flyer.change;
			this.setState({flyer});
			let params = new URLSearchParams();
			params.append('service', this.state.service.id);
			params.append('flyer', flyer.change);
			await postApi(`/v3/portal/discord/api`, params);
			
			await this.getDiscord();
			return;
		}
		flyer.current = this.state.discord.guild.flyer;
		flyer.change = item.target.value;
		this.setState({flyer});
	}

	async changeLive(item, save = false, cancel = false) {
		let live = this.state.live;
		if( cancel ) {
			live.current = this.state.discord.guild.live;
			live.change = this.state.discord.guild.live;
			this.setState({live});
			return;
		}
		if( save ) {
			live.current = live.change;
			this.setState({live});
			let params = new URLSearchParams();
			params.append('service', this.state.service.id);
			params.append('live', live.change);
			await postApi(`/v3/portal/discord/api`, params);
			
			await this.getDiscord();
			return;
		}
		live.current = this.state.discord.guild.live;
		live.change = item.target.value;
		this.setState({live});
	}


	async changeClips(item, save = false, cancel = false) {
		let clips = this.state.clips;
		if( cancel ) {
			clips.current = this.state.discord.guild.clips;
			clips.change = this.state.discord.guild.clips;
			this.setState({clips});
			return;
		}
		if( save ) {
			clips.current = clips.change;
			this.setState({clips});
			let params = new URLSearchParams();
			params.append('service', this.state.service.id);
			params.append('clips', clips.change);
			await postApi(`/v3/portal/discord/api`, params);
			
			await this.getDiscord();
			return;
		}
		clips.current = this.state.discord.guild.clips;
		clips.change = item.target.value;
		this.setState({clips});
	}


	async changeDJRole(item, save = false, cancel = false) {
		let djrole = this.state.djrole;
		if( cancel ) {
			djrole.current = this.state.discord.guild.djrole;
			djrole.change = this.state.discord.guild.djrole;
			this.setState({djrole});
			return;
		}
		if( save ) {
			djrole.current = djrole.change;
			this.setState({djrole});
			let params = new URLSearchParams();
			params.append('service', this.state.service.id);
			params.append('djrole', djrole.change);
			await postApi(`/v3/portal/discord/api`, params);
			
			await this.getDiscord();
			return;
		}
		djrole.current = this.state.discord.guild.djrole;
		djrole.change = item.target.value;
		this.setState({djrole})
	}


	async saveSocialDiscord() {
		let params = new URLSearchParams();
		params.append('service', this.state.service.id);
		const outputData = await this.editorInstance.current.save();
		if( outputData.blocks.length === 0 ) {
			if( !window.confirm('Contents for the daily flyer have been removed and would you like to reeset back to default contents?')) return;
			params.append('reset', true);
		}
		params.append('socialDiscord', JSON.stringify(outputData.blocks));
		await postApi(`/v3/portal/discord/api`, params);
		await this.getDiscord();
	}
	

	async assignMissingDj(discord, uid) {
		if( discord ) {
			let assignMissingDjs = this.state.assignMissingDjs;
			let current = assignMissingDjs.find(elem=>elem.discord===discord);
			if( current ) {
				current.uid = uid;
			} else {
				assignMissingDjs.push({discord, uid});
			}
			this.setState({assignMissingDjs});
		}
	}
	
	
	async applyMissingDj(id) {
		let discord = this.state.discord;
		let missingDiscord = discord.members.find(elem=>elem.id===id)
		if( !missingDiscord ) return;
		let assignMissingDjs = this.state.assignMissingDjs;
		let missingUid = assignMissingDjs.find(elem=>elem.discord===id)
		if( !missingUid ) return;
		let params = new URLSearchParams();
		params.append('service', this.state.service.id);
		params.append('discord', missingUid.discord);
		params.append('assigndj', missingUid.uid);
		await postApi(`/v3/portal/discord/api`, params);
		missingDiscord.discord = true;
		this.setState({discord});
	}


	render() {
		const user = this.context;

		const guilds = this.state.discord.guilds.map((e,i) => {
			return (
				<Row key={i}>
					<div style={{width:90}}>
						<img src='' alt="discord" style={{width: 90, height: 90, border: '1px solid #555555', borderRadius: '50%'}} />
					</div>
					<Col>
						{e.name}<br />
						<Button size="sm" onClick={()=>this.authoriseGuild(e.id)}>Authorise</Button>
					</Col>
				</Row>
			)
		});


		return (
			<>
				<div className="d-sm-flex d-block align-items-center justify-content-between page-header-breadcrumb">
					<h4 className="fw-medium mb-0">Discord</h4>
					<div className="ms-sm-1 ms-0">
						<nav>
							<ol className="breadcrumb mb-0">
								<li className="breadcrumb-item"><Link to={`/${this.state.service.id}`}>{this.state.service.name}</Link></li>
								<li className="breadcrumb-item active" aria-current="page">Dashboard</li>
							</ol>
						</nav>
					</div>
				</div>

				{this.state.service.status === true &&
					<div className="main-content app-content">
						<div className="container-fluid">
							<Row>
									
								<Col lg={12}>
                  <div className="card custom-card">
										<div className="card-header p-0">
											<div className="d-flex p-3 ">
												<div className="">
													<svg className="me-4  bg-success-transparent  alt-notify" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path fill="#75cfa5" d="m20.34 9.32-13.99-7a3 3 0 0 0-4.08 3.9L4.41 11l.26.59a1.06 1.06 0 0 1 0 .82l-.26.59-2.14 4.78a2.954 2.954 0 0 0 .67 3.38A2.966 2.966 0 0 0 5 22a3.141 3.141 0 0 0 1.35-.32l13.99-7a2.993 2.993 0 0 0 0-5.36Z"></path><path fill="#198754" d="M14.46 12a.997.997 0 0 1-1 1H4.41l.26-.59a1.06 1.06 0 0 0 0-.82L4.41 11h9.05a.997.997 0 0 1 1 1Z"></path></svg>
												</div>
												<div className="mt-0 text-start">
													<span className="fs-14 fw-semibold">Discord</span>
													<p className="fs-13 text-muted mb-0">Extend the schedule and stream info into Discord</p>
												</div>
                      </div>
                    </div>
										<TestService service={this.state.service.id} worker={user.worker[this.state.service.id]} />
										
                  </div>
                </Col>

								{this.state.discord.active === false ?
									<Col xs={12}>
										<div className="card custom-card custom-frame">
											<div className="card-header justify-content-between">
												<div className="card-title">
													Enable Discord
												</div>
											</div>
											<div className="card-body">
												<Row>
													<Col xs={12}>
														<p>
															Step 1 - Invite Ultrastream Bot to your server
														</p>
													</Col>
													<div style={{width:90}}>
														<img src='' alt="discord" style={{width: 90, height: 90, border: '1px solid #555555', borderRadius: '50%'}} />
													</div>
													<Col>
														<a href={this.state.discord.bot} target="_blank" rel="noreferrer"><Button size="sm">Invite</Button></a>
													</Col>
													<Col xs={12} className="p-2"></Col>
													{this.state.discord.guilds.length===0?
														<>
															<Col xs={12}>
																<p>
																	Step 2 - Access your Discord account to verify the Discord server.
																</p>
															</Col>
															<div style={{width:90}}>
																<img src='' alt="discord" style={{width: 90, height: 90, border: '1px solid #555555', borderRadius: '50%'}} />
															</div>
															<Col>
																<a href={this.state.discord.api} target="_blank" rel="noreferrer"><Button size="sm" onClick={()=>this.authorise()}>Authorise</Button></a>
															</Col>
														</>
													:
														<>
															<Col xs={12}>
																<p>
																	Step 3 - Select your Discord server:
																</p>
															</Col>
															{guilds}
														</>
													}
												</Row>
											</div>
										</div>
									</Col>
								:
									<>
										<Col lg={12}>
											<div className="card custom-card">
												<div className="card-header">
													<div className="card-title">
														DJ Schedule
													</div>
												</div>
												<div className="card-body">
													<p>
														Interact the current schedule into Discord
													</p>
													<Row>
														<Col sm={6}>
															Select Channel<br />
															<select className="form-select" aria-label="Default select example" value={this.state.schedule.change} onChange={this.changeSchedule}>
																<option value="">Disabled - Open this select menu</option>
																{(() => {
																	return this.state.discord.guild.channels.map((e,i) => {
																		return (
																			<option key={i} value={e.id}>{e.name}</option>
																		)
																	})
																})()}
															</select>
															{this.state.schedule.current !== this.state.schedule.change &&
																<ButtonGroup>
																	<Button size="sm" onClick={()=>this.changeSchedule('', true, false)}>Save</Button>
																	<Button size="sm" onClick={()=>this.changeSchedule('', false, true)}>Cancel</Button>
																</ButtonGroup>
															}
														</Col>
														<Col sm={6}>
															<DiscordMessage messages={this.state.message_schedule} deafult={''} />
														</Col>
													</Row>
												</div>
												
											</div>
										</Col>

										<Col lg={12}>
											<div className="card custom-card">
												<div className="card-header">
													<div className="card-title">
														Schedule Flyers
													</div>
												</div>
												<div className="card-body">
													<p>
														Post the flyers into Discord
													</p>
													<Row>
														<Col sm={6}>
															Select Channel<br />
															<select className="form-select" aria-label="Default select example" value={this.state.flyer.change} onChange={this.changeFlyer}>
																<option value="">Disabled - Open this select menu</option>
																{(() => {
																	return this.state.discord.guild.channels.map((e,i) => {
																		return (
																			<option key={i} value={e.id}>{e.name}</option>
																		)
																	})
																})()}
															</select>
															{this.state.flyer.current !== this.state.flyer.change &&
																<ButtonGroup>
																	<Button size="sm" onClick={()=>this.changeFlyer('', true, false)}>Save</Button>
																	<Button size="sm" onClick={()=>this.changeFlyer('', false, true)}>Cancel</Button>
																</ButtonGroup>
															}<br />
															<div className="form-control form-control-sm" style={{marginBottom: 10}}>
																<ReactEditorJS
        													/*tools={Raw}*/
																	onInitialize={instance => (this.editorInstance.current = instance)}
        													data={{blocks: (this.state.socialDiscord&&this.state.socialDiscord.length>0)?this.state.socialDiscord:[]}}
																	
																/><br />
															</div>
															<Button size="sm" onClick={()=>this.saveSocialDiscord()}>Save</Button>
														</Col>
														<Col sm={6}>
															<DiscordMessage messages={this.state.message_flyer} deafult={''} />
														</Col>
													</Row>
												</div>
												
											</div>
										</Col>

										<Col lg={12}>
											<div className="card custom-card">
												<div className="card-header">
													<div className="card-title">
														Schedule Live Streams & Clips
													</div>
												</div>
												<div className="card-body">
													{/*<p>
														Post the flyers into Discord
													</p>*/}
													<Row>
														<Col sm={6}>
															Livestream: Select Channel<br />
															<select className="form-select" aria-label="Default select example" value={this.state.live.change} onChange={this.changeLive}>
																<option value="">Disabled - Open this select menu</option>
																{(() => {
																	return this.state.discord.guild.channels.map((e,i) => {
																		return (
																			<option key={i} value={e.id}>{e.name}</option>
																		)
																	})
																})()}
															</select>
															{this.state.live.current !== this.state.live.change &&
																<ButtonGroup>
																	<Button size="sm" onClick={()=>this.changeLive('', true, false)}>Save</Button>
																	<Button size="sm" onClick={()=>this.changeLive('', false, true)}>Cancel</Button>
																</ButtonGroup>
															}<br />
															{/*<div className="form-control form-control-sm" style={{marginBottom: 10}}>
																<ReactEditorJS
        													/*tools={Raw}*
																	onInitialize={instance => (this.editorInstance.current = instance)}
        													data={{blocks: (this.state.socialDiscord&&this.state.socialDiscord.length>0)?this.state.socialDiscord:[]}}
																	
																/><br />
															</div>*/}
															{/*<Button size="sm" onClick={()=>this.saveSocialDiscord()}>Save</Button>*/}
															Clips: Select Channel<br />
															<select className="form-select" aria-label="Default select example" value={this.state.clips.change} onChange={this.changeClips}>
																<option value="">Disabled - Open this select menu</option>
																{(() => {
																	return this.state.discord.guild.channels.map((e,i) => {
																		return (
																			<option key={i} value={e.id}>{e.name}</option>
																		)
																	})
																})()}
															</select>
															{this.state.clips.current !== this.state.clips.change &&
																<ButtonGroup>
																	<Button size="sm" onClick={()=>this.changeClips('', true, false)}>Save</Button>
																	<Button size="sm" onClick={()=>this.changeClips('', false, true)}>Cancel</Button>
																</ButtonGroup>
															}<br />
														</Col>
														<Col sm={6}>
															{/*<DiscordMessage messages={this.state.message_flyer} deafult={''} />*/}
														</Col>
													</Row>
												</div>
												
											</div>
										</Col>

										<Col lg={12}>
											<div className="card custom-card">
												<div className="card-header">
													<div className="card-title">
														DJ Clients
													</div>
												</div>
												<div className="card-body">
													<p>
														Auto Assign the DJ rank onto members
													</p>
													<Row>
														<Col sm={6}>
															Select Role<br />
															<select className="form-select" aria-label="Default select example" value={this.state.djrole.change} onChange={this.changeDJRole}>
																<option value="">Disabled - Open this select menu</option>
																{(() => {
																	return this.state.discord.guild.roles.map((e,i) => {
																		return (
																			<option key={i} value={e.id}>{e.name}</option>
																		)
																	})
																})()}
															</select>
															{this.state.djrole.current !== this.state.djrole.change &&
																<ButtonGroup>
																	<Button size="sm" onClick={()=>this.changeDJRole('', true, false)}>Save</Button>
																	<Button size="sm" onClick={()=>this.changeDJRole('', false, true)}>Cancel</Button>
																</ButtonGroup>
															}
														</Col>
														<Col xs={12} className="mt-2"></Col>
														<Col sm={6}>
															Confirmed Discord Members:
															{this.state.discord.members.filter(elem=>elem.discord===true).map((e,i) => {
																	return (
																		<div key={i}>
																			<img src={e.avatar} className="avatar avatar-md me-2 mb-1" alt="avatar" />
																			{e.username.toLowerCase() === e._username.toLowerCase() || e.username.toLowerCase() === e._title.toLowerCase() ?
																				<Link to={`/profile/${e.username.toLowerCase()}`}>{e.username}</Link>
																			:
																				<Link to={`/profile/${e._username.toLowerCase()}`}>{e.username} => {e._title?e._title:e._username}</Link>
																			}
																		</div>
																	)
																})
															}
														</Col>
														<Col sm={6}>
															Not Confirmed Discord Members:
															<ul>
																{this.state.discord.members.filter(elem=>elem.discord===false).map((e,i) => {
																	let found = this.state.assignMissingDjs.find(elem=>elem.discord===e.id);
																	return (
																		<li key={i} className="d-flex align-items-center">
																			<div>
																				<img src={e.avatar} className="avatar avatar-md me-2 mb-1" alt="avatar" />
																			</div>
																			<span>
																				{e.username}
																			</span>
																			{this.state.missingDjs.length > 0 &&
																				<>
																					<select className="ms-2" onChange={(event)=>this.assignMissingDj(e.id, event.target.value)} value={this.state.assignMissingDjs.find(elem=>elem.discord===e.id)?.uid || 0}>
																						<option value="0">Please Select</option>
																						{this.state.missingDjs.map((f, j)=>{
																							return (
																								<option key={j} value={f.id}>{f.title?f.title:f.username}</option>
																							)
																						})}
																					</select>
																					{found && found.uid !== '0' &&
																						<Button size="sm" variant="light" className="ms-2" onClick={()=>this.applyMissingDj(e.id)}><FontAwesomeIcon icon="check" style={{color: '#008800'}} /></Button>
																					}
																				</>
																			}
																			{/*<Button size="sm" variant="light"><FontAwesomeIcon icon="trash" style={{color: '#FF0000'}} /></Button>*/}
																		</li>
																	)
																})}
															</ul>
														</Col>
													</Row>
												</div>
												
											</div>
										</Col>
									</>
								}
								
								
									
							</Row>
						</div>
					</div>
				}
			</>
		);
	}
}

const Discord = props => {
  const { service } = useParams();
  return <PortalAdminDiscord service={service} {...props} />
}
export default Discord;